// Configuración centralizada de fuentes para toda la aplicación
export const FONTS = {
  // Fuente principal para todo el sitio
  PRIMARY: 'Inter, sans-serif',
  
  // Fuente para títulos (opcional, si quieres mantener Times para títulos)
  TITLES: 'Inter, sans-serif',
  
  // Fuente para contenido de datos
  CONTENT: 'Inter, sans-serif',
  
  // Fuente para botones y controles
  CONTROLS: 'Inter, sans-serif',
  
  // Fuente para menús
  MENU: 'Inter, sans-serif',
};

// Función helper para obtener estilos de fuente
export const getFontStyle = (type = 'PRIMARY') => ({
  fontFamily: FONTS[type]
});

// Función helper para obtener estilos de título
export const getTitleStyle = (baseStyle = {}) => ({
  ...baseStyle,
  fontFamily: FONTS.TITLES
});

// Función helper para obtener estilos de contenido
export const getContentStyle = (baseStyle = {}) => ({
  ...baseStyle,
  fontFamily: FONTS.CONTENT
});

// Función helper para obtener estilos de controles
export const getControlStyle = (baseStyle = {}) => ({
  ...baseStyle,
  fontFamily: FONTS.CONTROLS
});

// Función helper para obtener estilos de menú
export const getMenuStyle = (baseStyle = {}) => ({
  ...baseStyle,
  fontFamily: FONTS.MENU
});
